<template>
  <div>
    <div class="lot-list">
      <LotList v-if="meetingId" @changeLotId='listChangeLot' @getMeetingData='getMeetingData' :meetingId="meetingId"
        :outLotId='activeLotId'></LotList>
    </div>
    <div class="lot-center">
      <div class="lot-conter-left">
        <LotContent ref="content" :meetingData='meetingData' :outLotId='activeLotId' :outData='lotData'></LotContent>
      </div>
      <div class="lot-conter-right">
        <LotTalk ref="lotTalk" v-if="activeLotId && meetingId " :auctioneerData='auctioneerData' :outLotData='lotData'
          :outLotId='activeLotId' :meetingId="meetingId"></LotTalk>
      </div>
    </div>
    <div class="lot-bottom-div">
      <el-row :gutter="24">
        <el-col :span="24">
          <LotInfo v-if="meetingData&&lotData" :meetingData='meetingData' :outData='lotData'></LotInfo>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import LotList from '@/components/hall/LotList.vue'
import LotContent from '@/components/hall/LotContent.vue'
import LotTalk from '@/components/hall/LotTalk.vue'
import LotInfo from '@/components/hall/LotInfo.vue'
import { getDetail, updateViewCount } from '@/api/biz/auction/auctionLot'
import { getAuctioneerApi } from '@/api/biz/user/auctioneer'
import { mapGetters } from "vuex";
import { getUrl } from "@/util/websocket";

export default {
  name: "LotDetailView",
  components: {
    LotList,
    LotContent,
    LotTalk,
    LotInfo
  },
  computed: {
    isLogin() {
      return this.userInfo.user_name;
    },
    userId() {
      return this.isLogin ? this.userInfo.user_id : parseInt(Math.random() * 999999);
    },
    userType() {
      if (this.isLogin) { // 登录则为竞拍人、不登录为游客
        return 1;
      }
      return 4;
    },
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      activeLotId: null,
      lotData: {},
      meetingId: null,
      meetingData: {},
      auctioneerData: {},
      websock: null,
      heartbeatInterval: null,
    }
  },
  methods: {
    getAuctioneerInfo() {
      getAuctioneerApi(this.meetingData.auctioneerId).then(res => {
        this.auctioneerData = res.data.data;
      })
    },
    /**
    * 初始化websocket
    */
    initWebSocket() {
      const ws = getUrl();
      this.websock = new WebSocket(ws);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
      this.websock.onopen = this.websocketonopen;
    },
    /**
     * weosocket数据接收
     */
    websocketonmessage(e) {
      console.log('收到了websocket文本消息', e)
      let data = JSON.parse(e.data);
      console.log("websocketData", data)
      if (data.msgType) {
        if (data.msgType != 301) {//刷新标的信息    
          setTimeout(() => {        
            this.getLotInfo();
          }, 1000); 
        }
        if (data.msgType != 201) {//除了更新报价——刷新消息通知
          this.$refs.lotTalk.getMessageList();
        }
        if (data.msgType == 104 || data.msgType == 201 || data.msgType == 202) {//报价、结束、回退——刷新报价列表     
          setTimeout(() => { 
            this.$refs.lotTalk.getPriceList();  
          }, 1000); 
        }
      }
    },
    /**
     * websocket数据发送,切换到对应的标的频道
     */
    websocketsend(data) {
      let obj = JSON.stringify(data);
      if (this.websock.readyState == 1) {
        this.websock.send(obj);
      }
      console.log('websocket发送数据：', obj);
    },
    /**
     * 连接建立失败重连
     */
    websocketonerror(e) {
        console.log('websocket通信连接异常',e)
    },
    websocketclose(e) {
      console.log(e,new Date())
      if (e && e.code !== 3333) {
        console.log('5s后开始重连......');
        clearInterval(this.heartbeatInterval); // 清除心跳定时器
        setTimeout(() => {
          this.initWebSocket();
          setTimeout(() => {
            if (this.websock.readyState == 1) {
              this.getLotInfo();
              console.log('已重新连接');
              this.startHeartbeat(); // 重新启动心跳定时器
            }
          },3000)
          ;
        }, 5000)
      }
    },
    websocketonopen() {
      console.log('WebSocket连接已打开');
      this.startHeartbeat(); // 启动心跳定时器
    },
    startHeartbeat() {
      this.heartbeatInterval = setInterval(() => {
        const heartbeatData = {
          msgType: 999, // 假设999是心跳消息类型
          data: "心跳"
        };
        this.websocketsend(heartbeatData);
      }, 10000); // 每10秒发送一次心跳消息
    },
    listChangeLot(lotId) {
      this.activeLotId = lotId;
      this.getLotInfo();
      this.$nextTick(() => {
        this.$refs.content.getApplyState();
        this.$refs.lotTalk.flushCurrentlotData();
      });
    },
    init() {
      this.getLotInfo();
    },
    getLotInfo() {
      getDetail(this.activeLotId).then(res => {
        this.lotData = res.data.data;
        this.meetingId = this.lotData.meetingId;
        this.$nextTick(() => {
          this.websocketsend({
            msgType: 11,
            data: JSON.stringify({
              userId: this.userId,
              userType: this.userType,
              lotId: this.activeLotId
            })
          });
          this.$refs.content.queryInfoByLotId(this.activeLotId);
        })
      });
      //更新围观次数      
      updateViewCount({ id: this.activeLotId });
    },
    getMeetingData(data) {
      this.meetingData = data;
      this.getAuctioneerInfo();
    },
  },
  created() {
    this.initWebSocket();
    this.activeLotId = this.$route.query.lotId;
    if (this.activeLotId) {
      this.init();
    }
  },
  beforeDestroy() {
    clearInterval(this.heartbeatInterval); // 清除心跳定时器
    if (this.websock) {
      this.websock.close();
    }
  }
}
</script>

<style scoped>
.lot-bottom-div {
  margin-top: 20px;
}
.lot-conter-right {
  display: inline-block;
  width: 299px;
  height: 440px;
  vertical-align: bottom;
  border-left: 1px solid rgba(215, 215, 215, 1);
}
.lot-conter-left {
  display: inline-block;
  width: 1000px;
  height: 440px;
  vertical-align: bottom;
}
.lot-info-div {
  min-height: 700px;
}
.lot-center {
  display: flex;
  margin-top: 20px;
  width: 1300px;
  height: 442px;
  opacity: 1;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
.lot-list {
  width: 1300px;
  height: 270px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
</style>